'use es6';

import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["active", "open", "options", "onButtonClick", "placement", "tooltip", "value", "splitButtonTestId", "disabled"];
import PropTypes from 'prop-types';
import { Component } from 'react';
import { findDOMNode } from 'react-dom';
import styled from 'styled-components';
import UIAbstractIconDropdown from './abstract/UIAbstractIconDropdown';
import UITextToolbarButton from './UITextToolbarButton';
import UITextToolbarIcon from './UITextToolbarIcon';
import Controllable from 'UIComponents/decorators/Controllable';
import UIButtonGroup from 'UIComponents/button/UIButtonGroup';
import UITooltip from 'UIComponents/tooltip/UITooltip';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const StyledButtonGroup = styled(UIButtonGroup).withConfig({
  displayName: "UITextToolbarSplitSelect__StyledButtonGroup",
  componentId: "sc-1fna6gn-0"
})(["& > *[aria-disabled='true']{border-color:transparent !important;}"]);
class UITextToolbarSplitSelectCore extends Component {
  constructor(...args) {
    super(...args);
    this.refCallback = element => {
      this._popoverTarget = findDOMNode(element);
    };
  }
  render() {
    const _this$props = this.props,
      {
        active,
        open,
        options,
        onButtonClick,
        placement,
        tooltip,
        value,
        splitButtonTestId,
        disabled
      } = _this$props,
      rest = _objectWithoutPropertiesLoose(_this$props, _excluded);
    const selectedOption = options.find(({
      value: val
    }) => val === value);
    const renderedIcon = selectedOption ? /*#__PURE__*/_jsx(UITextToolbarIcon, {
      disabled: disabled,
      name: selectedOption.icon
    }) : null;
    const popoverProps = {
      target: this._popoverTarget
    };
    return /*#__PURE__*/_jsx(UITooltip, {
      open: open ? false : undefined,
      placement: placement,
      title: tooltip,
      disabled: disabled,
      children: /*#__PURE__*/_jsxs(StyledButtonGroup, {
        disabled: disabled,
        children: [/*#__PURE__*/_jsx(UITextToolbarButton, {
          "data-test-id": splitButtonTestId,
          hovered: open ? true : undefined,
          onClick: onButtonClick,
          ref: this.refCallback,
          selected: active,
          disabled: disabled,
          children: renderedIcon
        }), /*#__PURE__*/_jsx(UIAbstractIconDropdown, Object.assign({
          open: open,
          options: options,
          popoverProps: popoverProps,
          value: value,
          disabled: disabled
        }, rest))]
      })
    });
  }
}
UITextToolbarSplitSelectCore.propTypes = Object.assign({}, UIAbstractIconDropdown.propTypes, {
  active: PropTypes.bool,
  onButtonClick: PropTypes.func,
  placement: UITooltip.propTypes.placement,
  tooltip: UITooltip.propTypes.title,
  splitButtonTestId: PropTypes.string
});
UITextToolbarSplitSelectCore.defaultProps = Object.assign({}, UIAbstractIconDropdown.defaultProps, {
  active: false,
  placement: 'bottom'
});
UITextToolbarSplitSelectCore.displayName = 'UITextToolbarSplitSelectCore';
const UITextToolbarSplitSelect = Controllable(UITextToolbarSplitSelectCore, ['open', 'value']);
UITextToolbarSplitSelect.displayName = 'UITextToolbarSplitSelect';
export default UITextToolbarSplitSelect;